import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppointmentDispatchTypes, useAppointmentDispatch } from '../../context/Appointment/appointment';
import { CTAButton } from '../../controls/ButtonBase';
import { useLocalization } from '../../context/Localization/localization';
import { Heading } from '../../controls/Heading/Heading';
import { ScrollableBody } from '../Layout/ScrollableBody/ScrollableBody';
import { AppRoutePaths, CustomerRoutePaths, PathName } from '../../helpers/Routes';
import { GMButtonGroup } from '../../controls/ButtonGroup';
import { GMRoundedIcon, GMSizedIcon } from '../../controls/Icon';

export const Customer: React.FC = () => {
    const Localization = useLocalization();
    const navigate = useNavigate();
    const appointmentDispatch = useAppointmentDispatch();

    React.useEffect(() => {
        appointmentDispatch({ type: AppointmentDispatchTypes.RemoveAppointment });
    }, [appointmentDispatch]);

    return (
        <ScrollableBody
            heading={
                <Heading
                    primaryHeading={Localization.OkayLetsGetStarted}
                    secondaryHeading={Localization.HaveYouVisitedUsBefore}
                    roundedIcon={
                        <GMRoundedIcon roundedBackgroundSize={'large'} themeType={'secondary'}>
                            <GMSizedIcon iconType={'Profile'} iconSize={'extraLarge'} />
                        </GMRoundedIcon>
                    }
                    showMustache
                />
            }
            proceedButtons={
                <GMButtonGroup
                    alignment={'center'}
                    buttons={[
                        (
                            <CTAButton
                                styleType={'primary'}
                                onClick={() => navigate(PathName(AppRoutePaths.Customer, CustomerRoutePaths.Lookup))}
                                label={Localization.YesIHave}
                                title={Localization.ClickToProceedExistingCustomer}
                                kioskOptions={{ square: true }}
                                id={Localization.ClickToProceedExistingCustomer}
                                ariaLabel={Localization.ClickToProceedExistingCustomer}
                            />
                        ),
                        (
                            <CTAButton
                                styleType={'secondary'}
                                onClick={() => navigate(PathName(AppRoutePaths.Customer, CustomerRoutePaths.Add))}
                                label={Localization.NoIHaveNot}
                                title={Localization.ClickToProceedNewCustomer}
                                kioskOptions={{
                                    squareOptions: {
                                        roundedIcon: (
                                            <GMRoundedIcon
                                                themeType={'primary'}
                                                allowInvertedPrimary
                                                roundedBackgroundSize={'large'}
                                            >
                                                <GMSizedIcon iconType={'No'} iconSize={'custom'} />
                                            </GMRoundedIcon>
                                        ),
                                    },
                                    square: true,
                                }}
                                id={Localization.ClickToProceedNewCustomer}
                                ariaLabel={Localization.ClickToProceedNewCustomer}
                            />
                        ),
                    ]}
                />
            }
            unsetButtons
        />
    );
};
